import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  text: {
    color: '#fff',
    fontSize: 28,
    fontWeight: 700,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <span className={classes.text}>P</span>;
};
